import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import LoadingIndicator from '../../LoadingIndicator';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Sidebar from '../../Sidebar';
import Details from '../../DeviationViews/Details';
import SubPaywall from '../../DeviationViews/Full/_partials/SubPaywall';
import PanelPopup from '../../DeviationPage/_partials/PanelPopup';
import { DeviationTypes } from '../../types/deviation';
import { getCommentableTypeForDeviationType, isExtendedDeviationFullyLoaded, } from '../redux/helpers';
import Comments from '../_partials/Comments';
import TierUpsell from '../_partials/TierUpsell';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import LiteratureTextualContent from '../../DeviationViews/TextualContent/Literature';
import s from './MobileDeviationPage.scss';
var MobileDeviationPage = function (_a) {
    var deviation = _a.deviation;
    var new_devpage_bg = useFlag('new_devpage_bg');
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var deviationType = getDeviationType(deviation);
    var isJournal = deviationType === DeviationTypes.JOURNAL;
    var isLiterature = deviationType === DeviationTypes.LITERATURE;
    var isJournalOrLit = isJournal || isLiterature;
    var typeId = deviation.typeId, deviationId = deviation.deviationId;
    var commentableTypeId = getCommentableTypeForDeviationType(typeId);
    var _b = useSubscriptionTier(deviation), tier = _b.tier, isSubscribedButBlocked = _b.isSubscribedButBlocked, needsSubscription = _b.needsSubscription;
    var isBlocked = needsSubscription || isSubscribedButBlocked;
    return (React.createElement("div", { className: classnames(s['root'], new_devpage_bg && s['new_devpage_bg']) },
        React.createElement(ArtStage, { deviation: deviation }),
        React.createElement(ActionBar, { deviation: deviation }),
        isLiterature && (React.createElement("div", { className: s['lit-content'] },
            React.createElement(LiteratureTextualContent, { deviation: deviation }))),
        React.createElement(PanelPopup, { deviation: deviation, actionBarType: "primary", className: s['large-popover-uplifted'] }),
        React.createElement(Details, { contentClassName: s['details'], deviation: deviation }),
        React.createElement(UserGiftSaleBanner, { user: deviation.author }),
        isJournalOrLit && isBlocked && (React.createElement(SubPaywall, { deviation: deviation, showImage: false })),
        isExtendedLoaded ? (React.createElement(React.Fragment, null,
            !isBlocked && (React.createElement(Comments, { key: "".concat(commentableTypeId, ":").concat(deviationId), deviation: deviation, className: s['comments'] })),
            !isBlocked && !!tier && (React.createElement(TierUpsell, { className: s['upsell'], deviation: deviation })),
            React.createElement("div", { className: s['sidebar'] },
                React.createElement(Sidebar, { deviation: deviation })))) : (React.createElement(LoadingIndicator, { className: s['lloader'], view: "llama" })),
        isBlocked && !!tier && (React.createElement(TierUpsell, { className: s['upsell'], deviation: deviation }))));
};
MobileDeviationPage.displayName = 'MobileDeviationPage';
export default MobileDeviationPage;
//# sourceMappingURL=MobileDeviationPage.js.map